import styled from '@emotion/styled';
import { screenSizes } from '../Literals';

export const GroupsRegistrationComponent = styled('div')`
  width: 90%;
  max-width: ${screenSizes.desktop};
  margin: 0 auto;
  padding: 1.5rem 1rem 2.5rem;
  box-sizing: border-box;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.07);
  border: 1px solid #e9ecef;
  text-align: left;

  &.embedded {
    width: 100%;
    max-width: 100%;
    margin: 0;
    padding: 0;
    background: transparent;
    border: none;
    border-radius: 0;
    box-shadow: none;
  }

  @media only screen and (max-width: ${screenSizes.tablet}) {
    width: 100%;
    padding: 1.25rem 1rem 2rem;
    border-radius: 12px;

    &.embedded {
      padding: 0;
      border-radius: 0;
    }
  }

  @media only screen and (max-width: ${screenSizes.mobile}) {
    padding: 0.85rem 0.75rem 1.25rem;
    border-radius: 10px;

    &.embedded {
      padding: 0;
      border-radius: 0;
    }
  }

  h1 {
    text-align: center;
    margin: 0 0 0.65rem;
    color: #1a1a1a;
    font-size: 1.65rem;
    font-weight: 700;
    line-height: 1.25;

    @media only screen and (max-width: ${screenSizes.mobile}) {
      font-size: 1.3rem;
    }
  }

  .flow-intro {
    color: #666;
    font-size: 0.92rem;
    line-height: 1.55;
    margin: 0 auto 1.25rem;
    text-align: center;
    max-width: 36rem;
  }

  p {
    &.title {
      font-size: 35px;
      margin: 0 0 9px 0;
    }
  }

  .Registration__form {
    margin-top: 0.5rem;
  }

  input + label {
    text-align: start;
  }

  /* Member log step — flat inside page card */
  .member-log-form {
    background: transparent;
    border: none;
    border-radius: 0;
    box-shadow: none;
    padding: 0;
    text-align: center;
    width: 100%;
    max-width: 420px;
    margin: 0 auto;
    display: block;
  }

  .member-log-title {
    display: block;
    font-size: 1.65rem;
    font-weight: 700;
    color: #1a1a1a;
    margin: 0 0 0.5rem;
    padding: 0;
    text-align: center;

    @media only screen and (max-width: ${screenSizes.mobile}) {
      font-size: 1.3rem;
    }
  }

  .member-log-subtitle {
    color: #666;
    font-size: 0.92rem;
    line-height: 1.5;
    margin: 0 0 1.25rem;
    text-align: center;
  }

  .member-log-fields {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 0.85rem;
    margin: 0 auto 1rem;
    width: 100%;

    .ui.input,
    .Registration__input,
    .Registration__input-identification,
    .Registration__input-phone {
      width: 100% !important;
      max-width: 100% !important;
      display: block !important;
      margin: 0 !important;
    }

    .ui.input > input {
      width: 100% !important;
      min-height: 2.85rem;
      border-radius: 12px !important;
      border: 1px solid #e2e8f0 !important;
      padding: 0.75rem 1rem !important;
      font-size: 0.95rem !important;
    }

    .ui.input.error > input {
      border-color: #e0b4b4 !important;
      background: #fff6f6 !important;
    }
  }

  .member-log-error {
    color: #db2828;
    font-size: 0.88rem;
    margin: 0 0 0.75rem;
    padding: 0.6rem 0.85rem;
    background: #fff6f6;
    border: 1px solid #e0b4b4;
    border-radius: 8px;
    text-align: center;
  }

  .member-log-submit {
    width: 100% !important;
    max-width: 100% !important;
    margin: 0.5rem auto 0 !important;
    border-radius: 999px !important;
    background: #1a1a1a !important;
    color: #fff !important;
    font-weight: 700 !important;
    padding: 0.95rem 1.5rem !important;
    font-size: 1rem !important;

    &:hover {
      background: #333 !important;
    }
  }

  /* Group selection step — flat inside page card */
  .selectGroup.ui.segment {
    background: transparent !important;
    border: none !important;
    box-shadow: none !important;
    padding: 0 !important;
    margin: 0 !important;
  }

  .selectGroup-back.ui.button {
    background: #f1f3f5 !important;
    color: #444 !important;
    border-radius: 999px !important;
    font-weight: 600 !important;
    margin: 0 0 1.25rem !important;
    box-shadow: none !important;
    padding: 0.65rem 1.1rem !important;
  }

  .selectGroup-badge {
    display: inline-block;
    background: #e8f6fc;
    color: #1a6f8f;
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    padding: 0.35rem 0.75rem;
    border-radius: 999px;
    margin-bottom: 0.75rem;
  }

  .selectGroup-header h2 {
    color: #1a1a1a;
    font-size: 1.65rem;
    font-weight: 700;
    margin: 0 0 0.65rem;
    text-align: left;

    @media only screen and (max-width: ${screenSizes.mobile}) {
      font-size: 1.3rem;
    }
  }

  .selectGroup-intro {
    color: #666;
    font-size: 0.92rem;
    line-height: 1.55;
    margin: 0 0 1.5rem;
    text-align: left;
  }

  .selectGroup-loading,
  .selectGroup-empty {
    color: #666;
    font-size: 0.92rem;
    line-height: 1.55;
    margin: 0;
    padding: 1rem 0;
  }

  .selectGroup-empty p {
    margin: 0 0 0.85rem;
  }

  .selectGroup-empty p:last-child {
    margin-bottom: 0;
  }

  .selectGroup-empty a {
    color: #2185d0;
  }

  .selectGroup-list {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .selectGroup-cycle {
    margin-top: 1.25rem;
    text-align: center;
  }

  .selectGroup-cycle-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    width: 100%;
    padding: 0.95rem 1.25rem;
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 14px;
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.06);
    color: #444;
    font-size: 0.95rem;
    font-weight: 700;
    cursor: pointer;
    transition: border-color 0.15s ease, box-shadow 0.15s ease;

    &:hover {
      border-color: #cbd5e1;
      box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
    }

    i.icon {
      color: #888;
      margin: 0 !important;
    }
  }

  .selectGroup-cycle-hint {
    margin: 1rem 0 0.5rem;
    color: #666;
    font-size: 0.88rem;
    line-height: 1.55;
  }

  .selectGroup-cycle-note {
    margin: 0;
    color: #888;
    font-size: 0.82rem;
    line-height: 1.5;
    font-style: italic;
  }

  .group-card {
    position: relative;
    display: flex;
    background: #fff;
    border: 1px solid #e9ecef;
    border-radius: 16px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.05);
    overflow: hidden;
    transition: box-shadow 0.15s ease, border-color 0.15s ease;

    &:hover {
      border-color: #d8e3ec;
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
    }
  }

  .group-card-accent {
    width: 6px;
    flex-shrink: 0;
    background: #7ec8e8;
  }

  .group-card-body {
    flex: 1;
    min-width: 0;
    padding: 1.1rem 1.15rem 1rem;
  }

  .group-card-top {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 0.75rem;
    margin-bottom: 0.65rem;
  }

  .group-card-meta {
    font-size: 0.68rem;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: #8a96a3;
    line-height: 1.4;
  }

  .group-card-badge {
    flex-shrink: 0;
    font-size: 0.68rem;
    font-weight: 600;
    color: #444;
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 999px;
    padding: 0.3rem 0.65rem;
    line-height: 1.3;
    text-align: right;
    max-width: 48%;
  }

  .group-card-name {
    font-size: 1.05rem;
    font-weight: 700;
    color: #1a1a1a;
    margin: 0 0 0.75rem;
    line-height: 1.35;
    text-transform: uppercase;
  }

  .group-card-details {
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
    margin-bottom: 1rem;
  }

  .group-detail-row {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: space-between;
    gap: 0.5rem 1rem;
  }

  .group-detail-address {
    margin: 0;
    padding-left: 1.35rem;
    color: #999;
    font-size: 0.8rem;
    font-style: italic;
    line-height: 1.4;
  }

  .group-detail-location {
    margin-left: auto;
  }

  .group-detail {
    display: flex;
    align-items: center;
    gap: 0.45rem;
    color: #555;
    font-size: 0.88rem;
    line-height: 1.4;

    i.icon {
      color: #8a96a3;
      margin: 0 !important;
      font-size: 0.9rem;
    }
  }

  .group-card-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    padding-top: 0.85rem;
    border-top: 1px solid #f0f2f5;
  }

  .group-leader {
    display: flex;
    align-items: center;
    gap: 0.6rem;
    min-width: 0;
    flex: 1;
  }

  .group-leader-avatar {
    width: 34px;
    height: 34px;
    border-radius: 50%;
    background: #e8edf2;
    color: #555;
    font-size: 0.75rem;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .group-leader-name {
    font-size: 0.88rem;
    color: #1a1a1a;
    line-height: 1.35;
    min-width: 0;

    strong {
      font-weight: 700;
    }
  }

  .group-join-btn.ui.button {
    flex-shrink: 0;
    background: #1a1a1a !important;
    color: #fff !important;
    border-radius: 999px !important;
    font-weight: 700 !important;
    font-size: 0.88rem !important;
    padding: 0.65rem 1rem !important;
    margin: 0 !important;
    box-shadow: none !important;

    &:hover {
      background: #333 !important;
    }

    i.icon {
      margin: 0 0 0 0.2rem !important;
    }
  }

  .group-preference-step {
    width: 100%;
    margin: 0;
    text-align: left;
  }

  .group-preference-focus {
    margin-top: 1.25rem;
    padding: 1rem 1.1rem;
    background: #f3f9fc;
    border: 1px solid #d8ecf5;
    border-radius: 12px;

    .group-preference-focus-label {
      font-size: 0.68rem;
      font-weight: 700;
      letter-spacing: 0.06em;
      text-transform: uppercase;
      color: #7a8a96;
      margin: 0 0 0.45rem;
    }

    .group-preference-focus-question {
      font-size: 0.95rem;
      font-weight: 600;
      color: #1a1a1a;
      margin: 0;
      line-height: 1.45;
    }
  }

  .group-preference-error {
    color: #db2828;
    font-size: 0.9rem;
    text-align: center;
    margin: 0 0 1rem;
    padding: 0.65rem 1rem;
    background: #fff6f6;
    border: 1px solid #e0b4b4;
    border-radius: 8px;
  }

  .group-preference-options {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    margin-bottom: 1.25rem;
  }

  .group-preference-card {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 1rem;
    width: 100%;
    padding: 1.15rem 1.2rem;
    border: 1.5px solid #e2e8f0;
    border-radius: 14px;
    background: #fff;
    cursor: pointer;
    text-align: left;
    transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;

    &.selected {
      border-color: #4db8e8;
      background: #e8f6fc;
      box-shadow: 0 0 0 1px #4db8e8;
    }

    .group-preference-card-title {
      font-weight: 700;
      font-size: 1rem;
      color: #1a1a1a;
      margin: 0 0 0.3rem;
    }

    .group-preference-card-subtitle {
      font-size: 0.85rem;
      color: #666;
      margin: 0;
      line-height: 1.45;
    }

    .group-preference-check {
      width: 28px;
      height: 28px;
      border-radius: 50%;
      border: 2px solid #d1d9e0;
      background: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;

      i.icon {
        color: #fff;
        margin: 0 !important;
        font-size: 0.85rem;
      }
    }

    &.selected .group-preference-check {
      border-color: #4db8e8;
      background: #4db8e8;
    }
  }

  .group-preference-actions {
    text-align: center;
    padding-top: 0.5rem;

    .group-preference-submit.ui.button.primary {
      width: 100%;
      border-radius: 999px !important;
      background: #1a1a1a !important;
      color: #fff !important;
      font-weight: 700 !important;
      padding: 1rem 2rem !important;
      font-size: 1rem !important;

      &:hover {
        background: #333 !important;
      }
    }
  }

  .selectedGroup {
    p {
      margin: 3px 0;
    }
  }

  .presencial {
    padding: 20px;
    .online {
      label {
        padding-top: 7px;
      }
    }
    label {
      padding: 0 20px;
      vertical-align: bottom;
    }
  }

  @media only screen and (max-width: ${screenSizes.tablet}) {
    .group-card-top {
      flex-direction: column;
      align-items: flex-start;
    }

    .group-card-badge {
      max-width: 100%;
      text-align: left;
    }

    .group-card-footer {
      flex-direction: column;
      align-items: stretch;
    }

    .group-join-btn.ui.button {
      width: 100%;
      justify-content: center;
    }
  }

  @media only screen and (max-width: ${screenSizes.tablet}) {
    .md-fullWidth {
      width: 100% !important;
    }
  }

  .fluid.multiple.selection {
    width: 75% !important;
    margin: 10px auto !important;
    .dropdown.icon {
      width: 60px !important;
    }
  }
`;
